// extracted by mini-css-extract-plugin
export default {"serviceFeeWrapper":"DeathPrayersForm-module--serviceFeeWrapper--QTXmc"};